module.exports = __webpack_public_path__ + "static/img/HARTFORD-MAPLE.ac90256.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/HARTFORD-MAPLE.png
// module id = lU3e
// module chunks = 0